<template>
    <div class="fanGraphSummary-footer">
        <div class="elements-container">
            <div class="element" v-if="nominalPointShow">
                <div class="nominal_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" v-bind:r="circleRadius"/>
                        </g>
                    </svg>
                </div>
                <span class="text">{{translate("nominal_point")}}</span>
            </div>

            <div class="element" v-if="workPointShow">
                <div class="work_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" v-bind:r="circleRadius"/>
                        </g>
                    </svg>
                </div>
                <span class="text">{{translate("work_point")}}</span>
            </div>
        </div>
        <div class="elements-container">
            <div class="element" v-if="requestedPointShow">
                <div class="requested_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" v-bind:r="circleRadius"/>
                        </g>
                    </svg>
                </div>
                <span class="text">{{translate("desired_point")}}</span>
            </div>
            <div class="element" v-if="characteristicLineShow">
                <span class="characteristic-line"/>
                <span class="text">{{translate("installation_characteristic")}}</span>
            </div>
        </div>
        <div class="elements-container">
            <div class="element" v-if="dynamicPressureShow">
                <span class="dynamic-pressure"/>
                <span class="text">{{translate("dynamic_pressure")}}</span>
            </div>
        </div>
        <div class="elements-container">
            <div class="element" v-if="powerLineShow">
                <span class="power-line"/>
                <span class="text">q<sub>vmax</sub>{{ getPower() ? `(${getPower()}kW)` : ``}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        key: 1,
        name: "FanGraphSummaryFooter",
        props: {
            dynamicPressureShow: {
                default: false
            },
            characteristicLineShow: {
                default: false
            },
            powerLineShow: {
                default: false
            },
            requestedPointShow: {
                default: false
            },
            workPointShow: {
                default: false
            },
            nominalPointShow: {
                default: false
            },
            circleRadius: 0
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
            getPower() {
                return this.$store.state.workPointParameters.elements['installed_power'].value
            }
        },
        watch: {
            powerLineShow() {
                this.key = (this.powerLineShow) ? 1 : 0
            }
        }
    }
</script>